import { useEffect, useState } from 'react'
import { PropertyList } from '../../../components/PropertyList'
import { PropertyListItem } from '../../../components/PropertyListItem'
import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from '@mui/material'
import { Tag } from '../../../components/Tag'
import { numberFormat } from '../../../utils'
import { Table } from 'antd'
import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import { useDispatch } from 'react-redux'
import { closeModal } from '../../../../store/reducers/modal/modal.slice'

interface Props {
  data: Record<string, any>
  isBlacklist?: boolean
  products?: any[]
  onConfirm: (form: any) => void
}
export const EditOrderQuickCreateForm = (props: Props) => {
  const dispatch = useDispatch()
  const { data, isBlacklist, products, onConfirm } = props
  const [form, setForm] = useState<Record<string, any>>()

  useEffect(() => {
    setForm({
      ...data,
      addressInfo: data.address.address,
      subDistrict: data.address.subDistrict,
      district: data.address.district,
      province: data.address.province,
      zipcode: data.address.zipcode,
    })
  }, [data])

  const handleInputChange = (e: any) => {
    const { name, value } = e.target
    setForm({
      ...form,
      [name]: value,
    })
  }

  const columns = [
    {
      title: 'รายการสินค้า',
      dataIndex: 'name',
      key: 'name',
      width: 220,
      render: (name: string) => {
        return <>{name}</>
      },
    },
    {
      title: 'ขนาด',
      dataIndex: 'size',
      key: 'size',
      width: 100,
      render: (size: string) => (
        <Typography variant="subtitle2" color="text.secondary">
          {size}
        </Typography>
      ),
    },
    {
      title: 'ราคาต่อชิ้น',
      dataIndex: 'price',
      key: 'price',
      width: 100,
      render: (price: number) => (
        <Typography variant="subtitle2" color="text.secondary">
          {numberFormat(price)}
        </Typography>
      ),
    },
    {
      title: 'จำนวน',
      dataIndex: 'quantity',
      key: 'quantity',
      width: 150,
      render: (quantity: number) => (
        <Typography variant="subtitle2" color="text.secondary">
          {quantity}
        </Typography>
      ),
    },
    {
      title: 'ส่วนลด',
      dataIndex: 'discount',
      key: 'discount',
      width: 100,
      render: (discount: number) => (
        <Typography variant="subtitle2" color="text.secondary">
          {numberFormat(discount)}
        </Typography>
      ),
    },
  ]

  return (
    <>
      <Box sx={{ width: '100%' }} mb={2}>
        <Grid container spacing={1}>
          <Grid item xs={12} lg={6}>
            <TextField
              fullWidth
              label="ชืี่อ-นามสกุล"
              name="name"
              value={form?.name}
              onChange={(e) => handleInputChange(e)}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              fullWidth
              label="หมายเลขโทรศัพท์"
              name="phone"
              value={form?.phone}
              onChange={(e) => handleInputChange(e)}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <TextField
              fullWidth
              label="ที่อยู่"
              name="addressInfo"
              value={form?.addressInfo}
              onChange={(e) => handleInputChange(e)}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              fullWidth
              label="ตำบล"
              name="subDistrict"
              value={form?.subDistrict}
              onChange={(e) => handleInputChange(e)}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              fullWidth
              label="อำเภอ"
              name="district"
              value={form?.district}
              onChange={(e) => handleInputChange(e)}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              fullWidth
              label="จังหวัด"
              name="province"
              value={form?.province}
              onChange={(e) => handleInputChange(e)}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              fullWidth
              label="รหัสไปรษณีย์"
              name="zipcode"
              value={form?.zipcode}
              onChange={(e) => handleInputChange(e)}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              fullWidth
              label="Social"
              name="social"
              value={form?.social || ''}
              onChange={(e) => handleInputChange(e)}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <TextField
              fullWidth
              label="วันที่คำสั่งซื้อ"
              name="date"
              value={form?.date || ''}
              onChange={(e) => handleInputChange(e)}
            />
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ width: '100%' }} mb={2}>
        <Table
          columns={columns}
          dataSource={products?.map((product: any, index: number) => {
            return {
              ...product,
              key: index,
            }
          })}
          bordered
          pagination={{ hideOnSinglePage: true }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Button
          startIcon={<ClearIcon />}
          color="inherit"
          onClick={() => {
            dispatch(closeModal())
          }}
          size="large"
          variant="contained"
        >
          ยกเลิก
        </Button>
        <Button
          startIcon={<SaveIcon />}
          color="primary"
          onClick={() => {
            onConfirm(form)
          }}
          size="large"
          variant="contained"
        >
          ยืนยัน
        </Button>
      </Box>
    </>
  )
}
